import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { currencyFormatter } from '../../utils'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Typography } from '@mui/material'
import { ORDER_HISTORY_DATE_FORMAT } from '../../consts'
import { format } from '@e3dc-react/shell/Libs/date'

interface OrderDetailsCardProps {
  orderDate: string
  referenceNumber: string | null
  cancelableUntil: string | null
  netPrice: number
}

const useStyles = makeStyles()(theme => ({
  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    maxWidth: '150px',
    minWidth: '150px',
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(2),
    },
  },

  detailsText: {
    marginTop: theme.spacing(1),
  },
}))

/*
 *This component shows data for order history details like , order date, reference number , cancelable, and the price.
 */
const OrderDetailsCard: React.FC<OrderDetailsCardProps> = ({ orderDate, referenceNumber, cancelableUntil, netPrice }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const formattedNetAmmount = currencyFormatter(netPrice)

  return (
    <>
      <Box className={classes.infoContainer}>
        <Typography variant="body2">{t('shop.order-history-card.order-date')}</Typography>
        <Typography variant="h3" className={classes.detailsText}>
          {format(new Date(orderDate), ORDER_HISTORY_DATE_FORMAT)}
        </Typography>
      </Box>
      <Box className={classes.infoContainer}>
        <Typography variant="body2">{t('shop.order-history-card.reference-number')}</Typography>
        <Typography variant="h3" className={classes.detailsText}>
          {referenceNumber ?? t('shop.order-history-card.no-reference-number')}
        </Typography>
      </Box>
      <Box className={classes.infoContainer}>
        <Typography variant="body2">{t('shop.order-history-card.net-amount')}</Typography>
        <Typography variant="h3" className={classes.detailsText}>
          {formattedNetAmmount}
        </Typography>
      </Box>
    </>
  )
}

export default OrderDetailsCard
